import styled from 'styled-components'

export const GroundingContainer = styled.div`
  margin: 3rem 4rem;
`
export const StyledHeaderContainer = styled.div`
  h3 {
    color: ${({ theme }) => theme.colors.InfinitiOnlyColor};
  }

  margin-bottom: 3rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`
